import { Backdrop, CircularProgress } from "@mui/material";

export function CustomTitle(title) {
  if (title) {
    return title
      .split(/[\s_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return title;
}

export const GetReadOnlyInputProps = (params) => ({
  ...params,
  inputProps: {
    ...params.inputProps,
    readOnly: true,
  },
});

export const DateFormater = (date, slashFormate = false) => {
  if (!date) return "";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return slashFormate ? `${mm}/${dd}/${yyyy}` : `${mm}-${dd}-${yyyy}`;
};

export const handleSessionOut = async () => {
  const name = "sessionout";
  window.parent.postMessage(name, "*");
  await new Promise((resolve) => setTimeout(resolve, 500));
};

export const Loader = ({ loading }) => {
  return (
    <Backdrop
      open={loading}
      sx={(theme) => ({
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      })}
    >
      <CircularProgress />
    </Backdrop>
  );
};

export const formatAmount = (amount) => {
  const num = Number(amount);
  if (isNaN(num)) {
    return amount;
  }
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
